import {useContext} from "react";

import VerifiedAssetsContext from "./VerifiedAssetsContext";
import {ContextUsedOutsideProviderError} from "../../../core/util/error/ContextUsedOutsideProviderError";

function useVerifiedAssets() {
  const value = useContext(VerifiedAssetsContext);

  if (!value) {
    throw new ContextUsedOutsideProviderError(VerifiedAssetsContext);
  }

  return value;
}

export {useVerifiedAssets};
